import {searchPageAttributesMap, SearchPageType} from '../search/search-config';
import {HibuUiConfiguration, TagOptions} from './config-types';
import {configLoaded, configTagOptionLoaded} from './config-actions';
import {useDispatch} from 'react-redux';
import {useEffect} from 'react';
import {useSearchPageType} from '../search/search-hooks';
import {AbortCategory, fetchJson, postJsonWithBody} from '../services/fetcher';
import {HibuSearchResponse} from '../search/search-types';
import {Option} from '../common/select/select';
import {HibuFacet, HibuFacetGroup} from '../facets/facetTypes';
import createOption from '../common/select/hibuSelectUtil';
import {getCurrentLanguage} from '../i18n-service';

export const CONFIG_API_ENDPOINT = '/config';

export const doConfigRequest = (
    searchPageType: SearchPageType,
): Promise<HibuUiConfiguration> => {
    return fetchJson<HibuUiConfiguration>(
        searchPageAttributesMap[searchPageType].endpoint + CONFIG_API_ENDPOINT,
        'GET',
        AbortCategory.CONFIG,
        true
    );
};

export function fetchTagOptions(tags: string[], callback: (HibuUiConfiguration) => void) {
    const requestBody = {displayLanguage: getCurrentLanguage(), facetFields: tags};

    const serviceEndpoint = '/searchElementsValues';
    return postJsonWithBody<HibuSearchResponse>(
        serviceEndpoint,
        JSON.stringify(requestBody),
        AbortCategory.MATA_INFO_OPTIONS
    ).then((data?: HibuSearchResponse) => {

        const facetOptions: TagOptions = data?.facets?.reduce((result: TagOptions, facet: HibuFacetGroup) => {
            const facetShortName: string = facet.fieldName.split('.').pop() || '';
            result[facetShortName] = facet.values.reduce((list: Option[], val: HibuFacet) => {
                const name = createOption(val.value, val.name);
                if (list.includes(name)) {
                    return list;
                }
                return [...list, name];
            }, []);

            return result;
        }, {}) || {};

        callback(facetOptions);
    })
        .catch((error) => {
            console.error('failed to fetch information dropdown options', error);
        });
}

export function useConfigRequest(): void {
    const dispatch = useDispatch();
    const searchPageType = useSearchPageType();

    useEffect(() => {
        doConfigRequest(searchPageType)
            .then((data) => {
                    const tags = data.search.tagsWithDropdown;
                    dispatch(configLoaded(data));
                fetchTagOptions(tags, (response) => dispatch(configTagOptionLoaded(response)));
                }
            ).catch((error) => console.error('failed to fetch configs', error));
    }, [dispatch, searchPageType]);
}




